import ITask from "../../../Utility/Task/ITask";
import WorldSystem from "../WorldSystem";
import { PlayerActions } from "../../../State/Player/PlayerActions";
import WorldTaskHelper from "./WorldTaskHelper";
import { IPlayerStateTaskData } from "State/Player/IPlayerState";

export default class WorldSyncTask implements ITask<WorldSystem> {
    protected tasksToClear: IPlayerStateTaskData[] = [];
    public *execute(system: WorldSystem): IterableIterator<number> {
        const state = system.store.getState().playerState;
        if (state.tasks.length > 0) {
            for (const taskData of state.tasks) {
                yield* WorldTaskHelper.executeTask(system, state, taskData);
            }
            PlayerActions.clearTasks();
        }
    }
}
